import { ROUTES as R } from '@aibees/elephant/router';
import { LabelGrouping, LabelVisibility } from '@aibees/elephant/types/label';
import { Chip, TextEllipsis } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Stack } from '@mui/material';
import { memo, useMemo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { ListNameProps as Props } from './types';

export const ListName = memo(({ className, item }: Props) => {
  const isPeople = item.grouping === LabelGrouping.PEOPLE;
  const listId = encodeURIComponent(item.id);
  const param = encodeURIComponent(`${item.name}::${listId}`);
  const url = isPeople
    ? `${R.searchPeople}?people_include_list=${param}`
    : `${R.searchCompany}?companies_include_list=${param}`;

  const chipColor = useMemo(() => {
    return item.grouping === LabelGrouping.PEOPLE ? 'success' : 'primary';
  }, [item.grouping]);

  const endIcon = useMemo(() => {
    return item.visibility === LabelVisibility.PRIVATE
      ? 'eye-lock-outline'
      : undefined;
  }, [item.visibility]);

  return (
    <Styled.Wrapper className={classnames('ListName', className)} sx={SX.root}>
      <Stack overflow="hidden">
        <Chip
          label={
            <Styled.Link to={url} target="_blank">
              <TextEllipsis value={item.name} variant="body4" />
            </Styled.Link>
          }
          color={chipColor}
          size="small"
          variant="filled"
          endIcon={endIcon}
        />
      </Stack>
    </Styled.Wrapper>
  );
});

ListName.displayName = 'ListName';
